import { useEffect } from 'react';

/**
 * Custom hook to inject JSON-LD schema into the document head
 * This bypasses react-helmet's issues with script tags
 */
export const useSchema = (schemaData) => {
  useEffect(() => {
    if (!schemaData) return;

    // Create script element
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    script.id = 'page-schema-' + Math.random().toString(36).substr(2, 9);

    // Append to head
    document.head.appendChild(script);

    // Cleanup on unmount
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [schemaData]);
};

/**
 * Component to render JSON-LD schema
 * Alternative to the hook if you prefer component-based approach
 */
export const SchemaMarkup = ({ data }) => {
  useEffect(() => {
    if (!data) return;

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    script.id = 'schema-markup-' + Math.random().toString(36).substr(2, 9);

    document.head.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [data]);

  return null;
};

export default useSchema;
